/**
 * Admin 사이트 메타·추적. 라우트 admin.site.site-meta.* 와 동기화.
 * 5개 섹션(SEO / 사이트 인증 / 트래킹 / robots.txt / 파비콘)은 각각의 라우트 · 페이지로 분리되어
 * 서버 렌더링으로 동작하므로 별도 JS 동작이 필요하지 않다.
 * 레지스트리 호환을 위해 no-op 메서드만 유지한다.
 */
import { Logger } from "../../utils/Logger";

const CTRL_TAG = "AdminSiteMetaController";

export const AdminSiteMetaController = {
    editSeo(): void { Logger.debug(`${CTRL_TAG}.editSeo (no-op)`); },
    updateSeo(): void { Logger.debug(`${CTRL_TAG}.updateSeo (no-op)`); },
    editVerification(): void { Logger.debug(`${CTRL_TAG}.editVerification (no-op)`); },
    updateVerification(): void { Logger.debug(`${CTRL_TAG}.updateVerification (no-op)`); },
    editTracking(): void { Logger.debug(`${CTRL_TAG}.editTracking (no-op)`); },
    updateTracking(): void { Logger.debug(`${CTRL_TAG}.updateTracking (no-op)`); },
    editRobots(): void { Logger.debug(`${CTRL_TAG}.editRobots (no-op)`); },
    updateRobots(): void { Logger.debug(`${CTRL_TAG}.updateRobots (no-op)`); },
    editFavicon(): void { Logger.debug(`${CTRL_TAG}.editFavicon (no-op)`); },
    uploadFavicon(): void { Logger.debug(`${CTRL_TAG}.uploadFavicon (no-op)`); },
    regenerateRobots(): void { Logger.debug(`${CTRL_TAG}.regenerateRobots (no-op)`); },
    index(): void { Logger.debug(`${CTRL_TAG}.index (no-op)`); },
};
